import P from '../../pages';
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { defaultMessages } from '../../../../libs/i18n/default'
import ReactOnRails from 'react-on-rails'
import FormHeader from './FormHeader'
import Redirector from './Redirector'
import Button from 'react-bootstrap/lib/Button'
import FormGroup from 'react-bootstrap/lib/FormGroup'
import { Redirect } from 'react-router-dom';
import ButtonGroup from './ButtonGroup';

class Interval extends React.Component {
  constructor(props){
    super(props);
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
  }

  back = e => {
    e.preventDefault();
    this.props.onGoBack();
  }

  submit = e => {
    this.props.onIntervalSubmit(
      {
        csrf_token: ReactOnRails.authenticityToken()
      }
    );
  }

  render(){
    const thisPage = P.INTERVAL_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={thisPage} className='profile'>
      <Redirector this_page={thisPage} page={page}/>
        <form>
        <div className="text-center"><img src="/images/host-sign-up/interval.png" /></div>
        <FormHeader title={content.pages.interval.title}/>
        <p>{content.pages.interval.body}</p>

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />
        </form>
      </div>
    );
  }
}

Interval.propTypes = {
   onIntervalSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Interval);
